import { ModalOverlay, ModalT1 } from "../../../../components/organisms/Modal";
import { PortalHeader } from "../../../../components/molecules/Header";
import { PortalFooter } from "../../../../components/molecules/Footer";
import { createPortal } from "react-dom";
import { StyledModalContent } from "../../../../components/organisms/Modal/Modal.styles";

const rootModals = document.getElementById("root-modals");

export function SubmitBill({ isLoading, handleSubmit, closeSubmitModal, nameOfBill }) {
  if (!rootModals) return null;

  const modalContent = (
    <ModalOverlay aria-modal="true" role="dialog" aria-labelledby="prepayment-title">
      <ModalT1 $minWidth={480} $maxWidth={600}>
        <PortalHeader
          title={`Submit Bill ${nameOfBill ? "#" + nameOfBill : ""}`}
          onClose={closeSubmitModal}
        />

        <StyledModalContent>
          Once submitted, this bill may be sent to an external system (if configured) and cannot be
          edited in Orderlink."
        </StyledModalContent>

        <PortalFooter
          isDisabled={isLoading}
          onApply={handleSubmit}
          onCancel={closeSubmitModal}
          applyTitle="Submit"
          isLoading={isLoading}
        />
      </ModalT1>
    </ModalOverlay>
  );

  return createPortal(modalContent, rootModals);
}
